import { SupportTicketStore } from './support-ticket';

export class SupportTicketRootStore {
	supportTicketStore: SupportTicketStore;

	init() {
		this.supportTicketStore = new SupportTicketStore();
	}
}
